import { render, staticRenderFns } from "./AddQuickLinkModal.vue?vue&type=template&id=bba1b08c&scoped=true&"
import script from "./AddQuickLinkModal.vue?vue&type=script&lang=js&"
export * from "./AddQuickLinkModal.vue?vue&type=script&lang=js&"
import style0 from "./AddQuickLinkModal.vue?vue&type=style&index=0&id=bba1b08c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bba1b08c",
  null
  
)

export default component.exports